import GifCardAmount from './GiftCardAmount';
import enhance from './GiftCardAmountContainer';

export default enhance(GifCardAmount);



// WEBPACK FOOTER //
// ./src/app/giftCard/Checkout/GiftCardAmount/index.js